import React from 'react';
import './CheckboxGroup.css';

export interface CheckboxOption {
	value: string;
	label: string;
	disabled?: boolean;
}

export interface CheckboxGroupProps {
	options: CheckboxOption[];
	selectedValues: Set<string>;
	onChange: (value: string) => void;
	orientation?: 'vertical' | 'horizontal';
	className?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
	options,
	selectedValues,
	onChange,
	orientation = 'vertical',
	className = '',
}) => {
	return (
		<div
			className={`checkbox-group checkbox-group-${orientation} ${className}`.trim()}
			role="group"
		>
			{options.map((option) => (
				<label
					key={option.value}
					className={`checkbox-group-label${option.disabled ? ' checkbox-group-label-disabled' : ''}`}
				>
					<input
						type="checkbox"
						checked={selectedValues.has(option.value)}
						onChange={() => onChange(option.value)}
						aria-label={option.label}
						disabled={option.disabled}
					/>
					<span>{option.label}</span>
				</label>
			))}
		</div>
	);
};
